var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { WorkspaceCryptoKeyFactory } from '../query-key-factories/WorkspaceCryptoKeyFactory';
export const useDecryptWithWorkspaceCommonKey = ({ encryptedValue, workspaceId, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    return useQuery({
        queryKey: WorkspaceCryptoKeyFactory.decrypt(workspaceId, encryptedValue),
        queryFn: () => lucidSdk
            .workspaceClient(workspaceId)
            .decryptStringWithWorkspaceCommonKey(encryptedValue),
        retry: false,
        staleTime: Infinity,
    });
};
_react_refresh_temp_1(useDecryptWithWorkspaceCommonKey, "Pdgrl5enHnzcAwRFvHrztXm3QfI=", false, () => [useLucidSdk, useQuery]);
